export function TenantLoadingState() {
  return <p>Loading tenants...</p>;
}
